import React, {Component} from 'react';
import './styles.scss';
import Translator from 'src/requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import Utils from 'src/utils/Utils';

class NewSectionInfoAddOn extends Component {
    constructor(props) {
        super(props);
        this.colorButton = Translator.get('Color_ColorPrimario')
        this.colorPromotionText = Translator.get('Color_ColorTextoPromocion')
    }

    componentDidMount() {
        const numberOfOffers = this.props.offers.length;
        Utils.querySelectorSafe('.aaf_header-compound-row .aaf_header-compound-header-logo', (backButton) => {
            backButton.classList.add('info-section__back-button');
            backButton.classList.add(numberOfOffers > 1 ? 'info-section__back-button--multiple' : 'info-section__back-button--single');
        });

        Utils.querySelectorSafe('.aaf_colored-button-yellow-principal', (anchorButton) => {
            anchorButton.style.backgroundColor = Translator.get('Color_ColorSecundario');
        });

        Utils.querySelectorSafe('.left-container', (infoContainer) => {
            infoContainer.classList.add('info-section__container');
        });
    }

    getPrice = (currency, price, key) => {
        const metadataText = Translator.get(key);
        return metadataText
            .replace(/@currency/g, currency)
            .replace(/@price/g, price);
    }

    render() {
        const [offer1, offer2] = this.props.offers;

        const numberOfOffers = this.props.offers.length;

        const {onClick} = this.props;

        const {currency, producttype, price, provider, landingBonus} = offer1 || {};

        const {currency: currency2, price: price2, provider: provider2, landingBonus: landingBonus2, producttype: producttype2} = offer2 || {};
        
        return(
            <div className='add-on__info-section'>
                <h2 className='info-section__title'>{Translator.get(`LandingComercial_TextoNombreAddOn_${producttype}`)}</h2>
                <p className={`info-section__offer-description ${numberOfOffers > 1 ? 'info-section__offer-description--multiple' : 'info-section__offer-description--single'}`}>
                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto1_${producttype}`), numberOfOffers > 1 ? 183  : 322)}
                </p>

                {
                    offer2 && (
                        <div>
                             <div className="info-section__offer__container-providers">
                                <div className='info-section__container-logo'>
                                    <img className='info-section__provider-logo-telmex' src={Asset.get(`LandingComercial_LogoTelmex_${producttype}`)}></img>
                                </div>
                                <div className='info-section__provider-info'>
                                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto2_${producttype}`), 105)}
                                </div>
                            </div>

                            <div className="info-section__offer__container-providers">
                                <div className='info-section__container-logo'>
                                    <img className='info-section__provider-logo-telcel' src={Asset.get(`LandingComercial_LogoTelcel_${producttype}`)}></img>
                                </div>
                                <div className='info-section__provider-info'>
                                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto3_${producttype}`), 105)}
                                </div>
                            </div>
                        </div>
                    )
                }

                <div>
                    <p className={`info-section__promotion-text ${numberOfOffers > 1 ? 'info-section__promotion-text--multiple' : 'info-section__promotion-text--single'}`}>
                        <span style={{color: this.colorPromotionText}}>{Utils.cutPlayerString(Translator.get(`LandingComercial_TextoPromo1_${producttype}`), numberOfOffers > 1 ? 41 : 33)}</span>
                        {' '}{Utils.cutPlayerString(Translator.get(`LandingComercial_TextoPromo2_${producttype}`), 10)}
                    </p>
                </div>

                <div>
                    <p className={`info-section__price ${numberOfOffers > 1 ? 'info-section__price--multiple' : 'info-section__price--single'}`}>
                        <span  className='info-section__price--fs48 info-section__price--fw700'>
                             {Utils.cutPlayerString(this.getPrice(currency, price,  `LandingComercial_TextoPrecio1_${producttype}`), 16)}
                        </span>
                        <span>
                            {Utils.cutPlayerString(Translator.get(`LandingComercial_TextoImpuestos2_${producttype}`), 21)}
                        </span>
                    </p>
                </div>

                <div>
                    <button 
                        className={`info-section__button focusable ${numberOfOffers > 1 ? 'info-section__button--multiple' : 'info-section__button--single'}`}
                        style={{ backgroundColor: this.colorButton }} 
                        onClick={() => onClick((producttype || provider), landingBonus && landingBonus.label)}
                    >
                        {Translator.get(`LandingComercial_TextoBoton1_${producttype}`)}
                    </button>
                </div>

                <div className={`info-section__cancel-text ${numberOfOffers > 1 ? 'info-section__cancel-text--multiple' : 'info-section__cancel-text--single'}`}>
                    {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto4_${producttype}`), numberOfOffers > 1 ? 64 : 173)}
                </div>

                {/* Info de la segunda oferta */}
                {offer2 && (
                    <div>
                        <div>
                            <p className='info-section__promotion-text info-section__promotion-text--multiple'>
                                {Utils.cutPlayerString(Translator.get(`LandingComercial_Texto5_${producttype2}`), 51)}
                            </p>
                        </div>

                         <div>
                            <p className='info-section__price info-section__price--multiple'>
                                <span  className='info-section__price--fs48 info-section__price--fw700'>
                                    {Utils.cutPlayerString(this.getPrice(currency2, price2,  `LandingComercial_TextoPrecio2_${producttype2}`), 16)}
                                </span>
                                <span>
                                    {Utils.cutPlayerString(Translator.get(`LandingComercial_TextoImpuestos2_${producttype2}`), 21)}
                                </span>
                            </p>
                        </div> 

                        <div>
                            <button 
                                className='info-section__button focusable info-section__button--multiple' 
                                style={{ backgroundColor: this.colorButton }}
                                onClick={() => onClick((producttype2 || provider2), landingBonus2 && landingBonus2.label)}
                            >
                                {Translator.get(`LandingComercial_TextoBoton2_${producttype2}`)}
                            </button>
                        </div>
                    </div>
                    
                )}
            </div>
        )
    }
        
}

export default NewSectionInfoAddOn;


// WEBPACK FOOTER //
// ./src/payments/DetailSelector/newSectionInfoAddOn/NewSectionInfoAddOn.jsx